import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { AcademicPartnerHit } from 'src/queries/user';
import { AffiliateCard } from 'src/components/AffiliateCard';
import styles from './SearchResults.module.scss';
interface Props {
	hits: AcademicPartnerHit[];
}
export const SearchResults: React.FC<Props> = ({ hits }) => {
	if (hits.length === 0) {
		return (
			<div className={styles.noResultsSection} data-testid='affiliate-no-results'>
				<Typography variant='h3'>No results</Typography>
				<Typography variant='body1'>
					Your search does not match any Direct Payment Program schools.
				</Typography>
			</div>
		);
	}

	return (
		<>
			{hits?.map(hit => {
				return <AffiliateCard hit={hit} key={hit.objectID} />;
			})}
		</>
	);
};
